import React from 'react';
import { Button } from 'antd';
import { useCreateDomainContentAnalysisProcessMutation } from '../service';

type Props = {
    domain: string;
    inProgress: boolean;
    setIsRefreshingAnalysis: (isLoading: boolean) => void;
};


export default function RefreshContentAnalysisButton({ domain, inProgress, setIsRefreshingAnalysis }: Props) {
    const [isLoading, setIsLoading] = React.useState(inProgress);
    const [startDomainContentAnalysis] = useCreateDomainContentAnalysisProcessMutation();

    const handleRefreshAnalysis = async () => {
        setIsLoading(true);
        setIsRefreshingAnalysis(true);
        await startDomainContentAnalysis({ domain }).unwrap();
        setIsRefreshingAnalysis(false);
    }

    React.useEffect(() => {
        setIsLoading(inProgress);
    }, [inProgress]);

    return (
        <Button
            className="refresh-analysis-button"
            size="small"
            loading={isLoading}
            onClick={handleRefreshAnalysis}
            icon={"sync"}
        >
            Refresh analysis
        </Button>
    );
}
